"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldRefTypePrefix = exports.ColumnRefTypePrefix = void 0;
exports.ColumnRefTypePrefix = '_colId.';
exports.FieldRefTypePrefix = '_field.';
